"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var marginTop = _a.marginTop;
            return ({
                marginTop: marginTop || theme.spacing(2.5),
            });
        },
        header: {
            textTransform: 'uppercase',
            color: theme.palette.primary.main,
        },
        divider: {
            marginTop: theme.spacing(2.5),
        },
    });
});
